import React from 'react'
import { TextField, FormControl, FormHelperText } from '@material-ui/core'

function Input({
  type,
  input,
  label,
  placeholder,
  disabled,
  required,
  disableLabelMove,
  InputProps,
  inputProps,
  customError,
  onKeyUp,
  onKeyDown,
  meta: { submitError, touched, error },
}) {
  let errorMessage = null
  let errorStatus = false

  if ((touched && (error || submitError)) || customError) {
    errorStatus = true
    errorMessage = error || submitError || customError
  }

  const props = {}
  if (onKeyUp) props.onKeyUp = onKeyUp
  if (onKeyDown) props.onKeyDown = onKeyDown

  return (
    <div className="form-group">
      <FormControl fullWidth component="div" error={errorStatus}>
        <TextField
          {...props}
          {...input}
          {...inputProps}
          error={errorStatus}
          type={type}
          label={label}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          InputLabelProps={{ shrink: disableLabelMove }}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          InputProps={InputProps}
        />
        {errorStatus && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormControl>
    </div>
  )
}

export default Input
